// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"653":"567d5be95c9ad14a","888":"c524822a5df83127"}[chunkId] + ".css";
};